<template>
  <ExternalQueryList
      endpoint="/api/v2/legal-texts"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      @show="legalText => $router.push(getUrl(legalText))"
  >
    <template v-slot:default="{ row: legalText }">
      <td>
        <router-link :to="getUrl(legalText)">
          {{ legalText.attributes.name }}
        </router-link>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  computed: {
    headlines() {
      return [
        {width: 22, text: 'Name'}
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(legalText) {
      return '/legal-texts/' + legalText.id + '/edit'
    }
  }
}
</script>
